import IcoMoon from '@/components/IcoMoon'
import * as style from './style'
import Avatar from '@/components/V2/Avatar'
import { ClassV2Session } from '@/shared/api-generated-types'
import { AIElementNames, eventsTracker } from '@/lib/eventsTracker'
import { CLassMetaData as Props } from '@/widgets/v2/AI/Chat/Message'
import { format } from 'date-fns'
import { soonestNonExpiredSession } from '@/lib/session'

const SessionCard = (props: Props): JSX.Element => {
  const soonestSession = soonestNonExpiredSession(props.aiSessions, props.durationSeconds)

  function getSessionStatus(soonestSession: ClassV2Session | null, durationSeconds?: number): JSX.Element | null {
    if (!soonestSession || !soonestSession.start || !durationSeconds) return null
    const now = new Date()
    const start = new Date(soonestSession.start)
    const end = new Date(start.getTime() + durationSeconds * 1000)

    if (now >= start && now < end) {
      return (
        <>
          <span className="font-bold text-[#FF4600]">
            <IcoMoon icon="live" size={20} />
          </span>
          <span className="font-bold text-[#FF4600]">ON NOW</span>
        </>
      )
    } else if (now < start) {
      return (
        <>
          <span className="font-bold text-[#2d2d32]">
            <IcoMoon icon="calendar" size={20} />
          </span>
          <span className="font-bold">{format(new Date(start), 'E dd LLL')}</span>
        </>
      )
    }
    return null
  }

  return (
    <div className="bg-white rounded-2xl overflow-hidden shadow-lg">
      <a
        href={props.class_detail_url}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => eventsTracker.handleOnClickAndTrackEvent(AIElementNames.BUTTON_CLASS_CARD)}
      >
        <div className={`${style.imageContainer}`}>
          {
            <img
              alt={'thumbnail'}
              src={props.imageUrl ?? '/images/image-placeholder-large.png'}
              className={style.image}
              loading="lazy"
              decoding="async"
            />
          }
        </div>
        {props.guideAvatarUrl && (
          <Avatar className="ml-3 mt-[-48px] border-white z-2" size="xsmd" src={props.guideAvatarUrl} outlined />
        )}
        <div className="p-4">
          <h3 className="font-bold text-base text-[#2D2D32] mb-1">{props.title}</h3>
          <p className="text-sm text-[#757582] mb-4">{props.guideName}</p>
          {soonestSession && soonestSession.start ? (
            props.durationSeconds && (
              <div className="absolute bottom-3 flex gap-1 text-[#2d2d32] items-center text-sm">
                {getSessionStatus(soonestSession, props.durationSeconds)}
                <span>{format(new Date(soonestSession.start), 'hh:mm aaa')}</span>
              </div>
            )
          ) : (
            <div className="absolute bottom-3 flex gap-1 text-[#2d2d32] items-center">No upcoming sessions</div>
          )}
        </div>
      </a>
    </div>
  )
}

export default SessionCard
